<template>
  <div>
      <el-tabs type="border-card">
        <el-tab-pane label="生涯是什么?" >
          <div class="text">
            <p>
              <b>生涯咨询是什么？</b>
            </p>
            <p>生涯咨询，是咨询师运用专业的咨询技术，通过一对一的“聊天”，协助你解决在学业规划、职业生涯方面的问题和困惑的过程。</p>
            <p>咨询方式：目前均为面对面的个体咨询。</p>
            <p>咨询时长：每次咨询一般为50分钟。如果是多次咨询，通常需要定期持续进行，频率一般为每周一次。</p>
            <p>
              <br>
            </p>
            <p>
              <b>咨询可以在哪些方面对你有所帮助？</b>
            </p>
            <p>如果你有以下方面的困惑，可以预约咨询师聊一聊，帮助你梳理思路、舒缓情绪、共同探讨解决办法：</p>
            <p>大学生活适应：大学环境、学习、人际、生活的适应等；</p>
            <p>学业规划：专业选择，学习方法和计划制定等；</p>
            <p>自我管理技能：时间管理、学业与生活/实习平衡、拖延问题等；</p>
            <p>自我了解：深入了解自己的兴趣、性格、能力、价值观等；</p>
            <p>职业探索：如何拓展职业选择范围、深入了解感兴趣的行业和职业信息等；</p>
            <p>职业定位：职业选择迷茫、职业选择困难等；</p>
            <p>毕业去向选择：工作、考研、出国的选择、跨专业考研等；</p>
            <p>求职技巧：如何写简历、进行面试准备，求职渠道和资源等；</p>
            <p>就业心理调适：没信心，没动力求职，考研焦虑，求职受挫等；</p>
            <p>就业形势与政策解读：选调生、基层就业、创业政策等；</p>
            <p>职场适应：岗位适应、职场人际适应、职场压力应对等。</p>
          </div>
        </el-tab-pane>
        <el-tab-pane label="怎么预约咨询">
          <div class="text">
            <p>
              <b>如何预约？</b>
            </p>
            <p>预约流程：登录预约系统-阅读知情同意并勾选同意-选择咨询师-填写咨询方案前置问卷-确认提交-预约成功-收到预约成功的短信消息，等待咨询。</p>
            <p>为了及时收到消息，请不要屏蔽系统发送的短信消息并及时查看。</p>
            <p>
              <br>
            </p>
            <p>
              <b>如何取消预约/续约？</b>
            </p>
            <p>
              <b>取消：</b>
            </p>            
            <p>如果你要取消咨询，需要在前一天晚上20点前取消。如，原定咨询时间是6月9日10点，请在8日20点前在本系统上取消。</p>
            <p>取消方法：登录预约系统，在【预约记录】里找到要取消的咨询，点击【取消咨询-提交取消原因】即为取消成功，同时你会收到取消成功的短信消息。</p>
            <p>
              <b>咨询师取消：</b>
            </p>  
            <p>咨询师因故取消咨询，你会收到取消的短信通知，同时我们的预约员也会电话联系你。</p>
            <p>如果你还想预约此咨询师，可以请预约员帮忙联系咨询师，咨询师会为你预留你们商量好的咨询时段，你需要在收到预留时段的24小时内确认接受，否则此时段会开放给其他同学。</p>
            <p>如果咨询师时间和你想要的不匹配，你可以在本系统上预约其他咨询师。</p>
            <p>
              <b>续约：</b>
            </p>             
            <p>如果想再次预约，请在每次咨询结束后与咨询师讨论，确定好下次的咨询时段。咨询师会在系统上为你预留咨询时段，你需要在收到预留时段的24小时内确认接受，否则为续约失败。</p>
            <p>或者你也可以自己在本系统上再次预约此咨询师。无论是续约成功还是失败，你都会收到短信通知。</p>        
          </div>
        </el-tab-pane>
        <el-tab-pane label="其他问题">
          <div class="text">
            <p>
              <b>一次咨询50分钟太短，可以延长咨询时间吗？</b>
            </p>
            <p>生涯咨询一般一次50分钟。因为一个人集中注意力的时长也就45到50分钟左右，就好比学校里每节课都是45分钟，时间过长咨访双方都会疲劳，沟通效果会很低。</p>
            <p>而且咨询并不是一个立竿见影的过程，要完全的解决问题一般需要做多次，需要与咨询师慢慢深入沟通。限制每次的咨询时间，也是为了有针对性的一步步解决每个问题，一个问题解决后为你留出体会思考的时间。其实时间的限制并不十分严格，只是相对而言这个时间段的效果会好一些。</p>
            <p>
              <b>为什么两次的咨询间隔为一周？一次咨询结束后，再约后天的咨询不可以吗？</b>
            </p>          
            <p>咨询其实是咨询+思考的过程。在和咨询师轻松地沟通时，会谈到一些观点和想法，会点破一些东西。然后需要一些时间来消化、沉淀和整理，并且咨询师给到的建议，也需要一些时间来尝试和实践。所以两次咨询时间不宜太短，一般为一周一次，这样咨询的效果也会好一些。</p>
            <p>
              <b>一次咨询可以解决问题吗？</b>
            </p>  
            <p>咨询持续时间因人而异，因为每个人想要解决的问题不同，问题的复杂程度不同。咨询次数可多可少，也可以随时终止，或者暂停一段时间再次咨询。</p>
            <p>咨询目标的实现，需要你和咨询师的共同努力，你的任何感受、想法，都可以与咨询师进行沟通、讨论。你是咨询的主角，咨询师可以提供的帮助包括陪伴、倾听、理解、反馈、建议。咨询师会鼓励你积极采取行动，因为生活是你采取行动或者不采取行动的结果。</p>
            <p>
              <b>可以在咨询时间外与咨询师联系吗？</b>
            </p>             
            <p>尽量不要。咨询师在咨询时段内，有责任履行咨询师的角色、遵循尊重、保密等原则。而在非咨询时段内，咨询师的角色和状态与在咨询时段内是不同的。如果在咨询时间外联系，会影响咨询效果。</p>
          </div>          
        </el-tab-pane>
      </el-tabs>      
      <el-button type="primary" round style="width:100%; margin-top:12px;"  @click="goback">返回首页</el-button>    
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  mounted() {
    document.title = '来访者咨询指南'
  },
  methods: {
     goback() {
      // this.$router.back();
      this.$router.push("home");
    },
  }
};
</script>


<style scoped>
>>> .el-tab-pane {
  height:600px;
  overflow:auto;
}

p{
  text-indent:24px;
  font-size:12px;
  line-height: 14px;
  margin-bottom: 10px;
}
</style>
